import { FC } from 'react';
import { Title } from '../title';
import { Drawer } from '@mui/material';
import { Close } from '@mui/icons-material';
import style from './sidebar.module.scss';

interface Props {
  children: JSX.Element;
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: FC<Props> = ({ children, title, isOpen, onClose }) => {
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} className={style.sidebar}>
      <div className={style.titleWrap}>
        <Title text={title} type="h2" />
        <Close className={style.closeIcon} onClick={onClose} />
      </div>
      <div className={style.content}>{children}</div>
    </Drawer>
  );
};

export default Sidebar;
